// extracted by mini-css-extract-plugin
export default {"paper":"Meatballs_paper__yLCrR","menu":"Meatballs_menu__F9Dnr","button":"Meatballs_button__wNC2-","menu__item":"Meatballs_menu__item__a5GCB"};